import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="container mt-5 mb-5">
            <div className="card shadow-lg p-4 text-start">
                <h2 className="text-start">Privacy Policy</h2>
                <p className="text-start text-muted">Effective Date: 03/03/2025</p>
                
                <h4 className="mt-4">1. Introduction</h4>
                <p>Welcome to <strong>All-Classes (Alhorreya App)</strong>. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application, particularly regarding the community features.</p>
                
                <h4 className="mt-4">2. Information We Collect</h4>
                <ul>
                    <li><strong>Personal Information:</strong> Name, email address, profile picture, and other details you provide when creating an account.</li>
                    <li><strong>Community Content:</strong> Posts, comments, messages, and other interactions within our communities.</li>
                    <li><strong>Usage Data:</strong> Information about how you use our app, including interactions with other users.</li>
                    <li><strong>Device and Technical Data:</strong> IP address, device type, operating system, and app version.</li>
                </ul>
                
                <h4 className="mt-4">3. How We Use Your Information</h4>
                <ul>
                    <li>Provide and improve our app's community features.</li>
                    <li>Facilitate user interactions and communication.</li>
                    <li>Personalize your experience.</li>
                    <li>Monitor and enforce community guidelines.</li>
                    <li>Respond to inquiries and provide support.</li>
                    <li>Enhance security and prevent fraud.</li>
                </ul>
                
                <h4 className="mt-4">4. Sharing Your Information</h4>
                <ul>
                    <li><strong>With Other Users:</strong> Your profile and posts in public or private communities may be visible to others.</li>
                    <li><strong>With Service Providers:</strong> We may use third-party providers to help operate our app.</li>
                    <li><strong>For Legal Compliance:</strong> If required by law, we may disclose information to authorities.</li>
                    <li><strong>For Protection:</strong> To protect the rights and safety of users and our platform.</li>
                </ul>
                
                <h4 className="mt-4">5. Your Choices and Rights</h4>
                <ul>
                    <li>Update or delete your profile information.</li>
                    <li>Adjust privacy settings to control visibility.</li>
                    <li>Request deletion of your account and associated data.</li>
                    <li>Opt-out of marketing communications.</li>
                </ul>
                
                <h4 className="mt-4">6. Data Security</h4>
                <p>We implement security measures to protect your data. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>
                
                <h4 className="mt-4">7. Third-Party Links and Services</h4>
                <p>Our app may contain links to third-party websites or services. We are not responsible for their privacy practices, so we encourage you to review their policies.</p>
                
                <h4 className="mt-4">8. Children’s Privacy</h4>
                <p>Our app is not intended for children under 13. We do not knowingly collect personal information from children.</p>
                
                <h4 className="mt-4">9. Changes to This Privacy Policy</h4>
                <p>We may update this policy from time to time. We will notify you of significant changes by updating the effective date or providing additional notice.</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;